import React, { useEffect, useState } from "react";
import poster from "../../asets/Images/MainHome/group_image.jpeg";
import Example_3Dcard from "../Home/Example_3Dcard";
import CountUp from "react-countup";
import style from "../globlecss.module.css";
import app_developer from "../../asets/Images/home-two-about.webp";
import award from "../../asets/Images/award.webp";
import { useInView }  from 'react-intersection-observer';


const About = () => {
  const { ref, inView } = useInView({ triggerOnce: false });
  const [startCount, setStartCount] = useState(false);

  useEffect(() => {
    if (inView) {
      setStartCount(false); 
      setTimeout(() => setStartCount(true), 100); 
    }
  }, [inView]);
  const counters = [
    { end: 1500, label: 'Highest Ranking', color: 'text-blue-500' },
    { end: 320, label: 'Great Results', color: 'text-green-500' },
    { end: 75, label: 'Strategies', color: 'text-yellow-500' },
    { end: 120, label: 'Top Experts', color: 'text-purple-500' },
  ];

  return (
   <>
     
      <div className="grid grid-cols-1 gap-8 md:p-2 md:grid-cols-2 py-4 px-4">
        <div className="col">
        <div className="md:ml-12">
        <h3 className="text-slate-800 text-6xl mb-3">Our Story</h3>
          <p className="text-justify tracking-wide text-lg leading-6 font-semibold">
          Founded on July 26th, 2025, manaChoice TechWorks (OPC) Pvt Ltd  was established by visionary founders, experts in diverse fields, with a mission to drive the growth of Startups and MSMEs through the power of software.</p>
          <p className="text-justify tracking-wide text-lg leading-6 font-semibold">Growing the organization came with challenges among which resource was a major one. Our proactive approach to address this issue involved training freshers within our organization and turning them into skilled professionals. This allowed us to build a strong talent pool, facilitating in-house recruitment as well.</p>
          <p className="text-justify tracking-wide text-lg leading-6 font-semibold">To expand further, we introduced a Free Training Program for College Students, which helped us establish our brand and attract more talented individuals. We also formed partnerships with emerging ventures to diversify our portfolio and strengthen our presence.</p>
          <p className="text-justify tracking-wide text-lg leading-6 font-semibold">Now, our focus lies on providing technical support and nurturing our marketing team. These pillars are essential for a strong and reliable system within our organization.</p>
        </div>
        </div>
        <div className="col md:p-4">
          <div className="relative z-10 flex flex-col items-center">
            <div className="">
              <Example_3Dcard image={poster} />
            </div>
             <div className="mt-2">
             <p className="font-light">Codesight Global Solutions Pvt Ltd has come a long way from its humble beginnings. Our dedication to excellence and empowering others continues to drive us forward, pushing the boundaries of innovation in the tech industry.</p>
             </div>
         
          </div>
        </div>
      </div>
     

     <div>

  <div className={style.counter1}>
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 p-12">
      {counters.map((item, index) => (
        <div
          key={index}
          className="flex flex-col items-center justify-center bg-slate-200 shadow-md rounded-2xl"
        >
         <h2 ref={ref} className={`text-6xl font-bold ${item.color}`}>
      {startCount && <CountUp end={item.end} duration={5} />}
    </h2>
          <p className="text-slate-600 mt-2 text-center text-base font-medium">
            {item.label}
          </p>
        </div>
      ))}
    </div>
  </div>

     


      <>
             <div className="bg-gradient-to-b from-pink-50 to-white-100 md:py-12">
               <div className="grid grid-cols-1 md:grid-cols-7 md:px-24 gap-4 m-2">
                 <div className="col-span-1 md:col-span-4 px-2">
                   <img
                     src={app_developer}
                     style={{ height: "440px" }}
                     className="cursor-pointer transition-all duration-300 ease-in-out transform hover:scale-110"
                     alt="about us"
                   />
                 </div>
                 <div className="md:col-span-3 flex flex-col justify-center items-start">
                   <img  src={award} style={{ height: "50px" }} alt="award" />
                   <h2 className="text-slate-900 text-4xl font-semibold">
                   Our Strategy
                   </h2>
                   <p className="text-slate-500 font-bolder">
                   Caspire aims to become a benchmark in the industry with the best practices, research & attaining new opportunities in all aspects for further development of your business be the best organization in a hassle-free environment to work.
                   </p>
                   <button className={style.btn_55}><span>LEARN MORE</span></button>


                 </div>
               </div>
             </div>
           </>
     </div>
</>
  );
};
export default About;
